import React, { useMemo } from 'react'
import { SectionPlaceholder } from 'src/components'
import { SkillTabPanel } from './components'
import { MenuLinks } from 'src/content'

export interface SkillsProps {}

export const Skills: React.FC<SkillsProps> = () => {
  const { MenuAnchor } = MenuLinks
  const [skillCategory, setSkillCategory] = React.useState('frontend')

  const handleSkillCategoryChange = (category: string) => {
    setSkillCategory(category)
  }

  const subtitle = useMemo(() => {
    return `select * from SKILLS where CATEGORY = '${skillCategory}';`
  }, [skillCategory])

  return (
    <SectionPlaceholder title="Skills & Tools" subTitle={subtitle} anchorClassName={MenuAnchor.Skills}>
      <SkillTabPanel handleCategoryChange={handleSkillCategoryChange} />
    </SectionPlaceholder>
  )
}
